import * as React from 'react';
import { getServingCompetitorSportId, IEventResultStore, IScreenInfo, StatisticsInApi } from 'eTip--common';
import { secondsToMinutesForMatchTime } from 'easit--utils';

import { Tooltip, CategoryIcon, IconTooltip } from 'common--design-library';

export interface ILiveEventCompetitor {
    isServer: boolean;
    name: string;
}

export interface ILiveEventInfoProps {
    id: number;
    name: string;
    hasResults: boolean;
    mainResult: IEventResultStore;
    competitors: ILiveEventCompetitor[];
    stateName: string;
    stateTime?: number;
    importantResults: IEventResultStore[];
    detailsCount: number;
    canShowIcon: boolean;
    graphicsPresentationId?: number; // for icon only
    onGoToDetail: (id: number) => void;
    onShowDetail: () => void;
    setFavoriteEvent: (value: boolean) => void | null;
    isFavorite?: boolean;
    children: React.ReactNode;
    isDetailOpened: boolean;
    isDetailOpenedBelow: boolean;
    categoryPath?: string;
    isMatchTracker: boolean;
    matchTrackerClick: () => void;
    isLiveStream: boolean;
    liveStreamClick: () => void;
    gameName: string;
    gameInfo: string;
    statistics: StatisticsInApi | null;
    onStatisticsAction?: (statistics: StatisticsInApi, eventName: string) => void;
    isLiveInPrematch: boolean;
    screenInfo: IScreenInfo;
}


export const LiveEventInfo = (props: ILiveEventInfoProps) => {
    // const isBaseball = eventDisciplineWrapper.isBaseball(props.graphicsPresentationId);

    return <div className="live-event-info">
        {
            props.canShowIcon &&
            <div className="mr-2 mt-1"><CategoryIcon categoryIconId={props.graphicsPresentationId} /></div>
        }
        <div className="event-info d-flex" onClick={(e) => { e.stopPropagation(); props.onShowDetail(); }}>
            <div className="watch-wrapper">
                {props.isLiveStream && <i className={"fa fa-desktop"} onClick={(e) => { e.stopPropagation(); props.liveStreamClick(); }}></i>}
                {props.isMatchTracker && <>{props.isLiveStream && <br />} <i className={"fa fa-eye"} onClick={(e) => { e.stopPropagation(); props.matchTrackerClick(); }}></i></>}
                {
                    !(props.isMatchTracker && props.isLiveStream)
                    && props.statistics && <IconTooltip
                        targetid={`iconstatistics_${props.statistics.id}`}
                        target={
                            <span id={`iconstatistics_${props.statistics.id}`} className="etip-stats" onClick={(e) => {
                                e.stopPropagation();
                                props.onStatisticsAction && props.onStatisticsAction(props.statistics, props.name);
                            }} />}
                    >
                        <div></div>
                    </IconTooltip>
                }
            </div>
            <div className="main-result-wrapper">
                {

                }
                {
                    props.isLiveInPrematch
                        ?
                        <span className="live-selection-flag">LIVE</span>
                        :
                        <>
                            <div className="main-result">{props.hasResults && props.mainResult ? `${props.mainResult.score1}:${props.mainResult.score2}` : <br />}</div>
                            <div>
                                <span className={`${props.isFavorite ? "fa fa-star" : "far fa-star"}`} onClick={(e) => { e.stopPropagation(); props.setFavoriteEvent(!props.isFavorite); }}></span>
                            </div>
                        </>
                }
            </div>
            <div className="event-name-wrapper">
                <div className="event-name">
                    <Tooltip
                        targetid={`tooltip_eventlist_${props.id}`} placement="top" autohide={false}
                        targetFactory={(p) => <div {...p} className="text-truncate event-id" onClick={(e) => { e.stopPropagation(); props.onGoToDetail(props.id); }} data-test-role="live-event-name">
                            <span className="text-truncate team-name">{props.competitors[0].name}
                                {props.competitors[0].isServer && <span className={`icon-score icon-sport-${getServingCompetitorSportId(props.graphicsPresentationId)}`}></span>}
                                { /* icon of a glove is bad isBaseball && props.competitors[1].isServer && <span className={`icon-score icon-sport-${getServingCompetitorSportId(props.graphicsPresentationId)}a`}></span> */}
                            </span>
                            {props.isLiveInPrematch && props.hasResults && props.mainResult && <span className="main-result">{`${props.mainResult.score1}:${props.mainResult.score2}`}</span>}
                            {props.competitors.length > 1
                                &&
                                <>
                                    {!props.isLiveInPrematch && <span className="px-1"> - </span>}
                                    <span className="text-truncate team-name">{props.competitors[1].name}
                                        {props.competitors[1].isServer && <span className={`icon-score icon-sport-${getServingCompetitorSportId(props.graphicsPresentationId)}`}></span>}
                                        { /* icon of a glove is bad isBaseball && props.competitors[0].isServer && <span className={`icon-score icon-sport-${getServingCompetitorSportId(props.graphicsPresentationId)}a`}></span> */}
                                    </span>
                                </>
                            }
                        </div>}
                    >
                        <div className="p-2 text-left">{props.name}<br />{props.categoryPath}</div>
                    </Tooltip>
                </div>
                <div className="other-details text-truncate">
                    <span style={{ whiteSpace: "nowrap" }}>{props.stateName}{props.stateTime != null && <>, {secondsToMinutesForMatchTime(props.stateTime)}'</>}&nbsp;-&nbsp;</span>

                    {props.importantResults && props.importantResults.length > 0 &&
                        <>
                            {
                                props.importantResults.map((result, indx) =>
                                    <span key={result.id} className={`${indx ? "pl-2" : ""} ${result.isGame ? "currentPeriodPart" : ""} ${result.isHalf ? "halfTime" : ""}`}>{result.score1}:{result.score2}</span>)}
                        </>
                    }
                </div>
            </div>
        </div>

        <div className="odds-list">
            <span className="d-flex align-items-center game-name">
                {
                    !props.isLiveInPrematch
                    && <>{props.gameName}
                        {
                            props.gameInfo?.length > 0 &&
                            <IconTooltip targetid={`live_list_iconinfo_${props.id}`} allowOnTouchScreen
                                placement="right"
                                target={
                                    <span id={`live_list_iconinfo_${props.id}`} className="etip-info ml-1" />
                                }
                            >
                                {props.gameInfo}
                            </IconTooltip>
                        }
                    </>
                }
            </span>
            {props.children}
        </div>

        <div className="detail-count-favortes-wrapper">
            <span className="detail-count" data-test-role="live-event-minidetail">
                {
                    props.isDetailOpened
                        ? props.isDetailOpenedBelow ? <span className="fa fa-caret-up"></span> : <span className="fa fa-caret-right"></span>
                        : <span> +{props.detailsCount}</span>
                }
            </span>
        </div>
    </div >
}
